export const LAST_USERNAME_LOCALSTORAGE_KEY = "lastUsername";
